import "./App.css";
import Navbar from "./Components/Navbar.js";
import Home from "./Pages/Home.js";
import About from "./Pages/About.js";
import Contact from "./Pages/Contact.js";
import Projects from "./Pages/Projects.js";
import Skills from "./Pages/Skills";
import ProjectPage from "./Pages/ProjectPage.js";

function App() {
  let component;
  const path = window.location.pathname;

  // Check if it's a project route with dynamic ID
  if (
    path.startsWith("/projects/") &&
    path !== "/projects" &&
    path !== "/projects/dev"
  ) {
    const projectId = path.split("/projects/")[1];
    component = <ProjectPage id={projectId} />;
  } else {
    switch (path) {
      case "/about":
        component = <About />;
        break;
      case "/contact":
        component = <Contact />;
        break;
      case "/skills":
        component = <Skills />;
        break;
      case "/projects":
        component = <Projects />;
        break;
      case "/projects/dev":
        component = <Projects />;
        break;
      default:
        component = <Home />;
        break;
    }
  }

  return (
    <>
      <Navbar />
      <div className="container">{component}</div>
    </>
  );
}

export default App;
